import type { Theme, Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiAppBar: Components<Theme>['MuiAppBar'] = {
  // ▼▼▼▼▼▼▼▼ ⚙️ PROPS ▼▼▼▼▼▼▼▼
  defaultProps: {
    color: 'transparent',
  },
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: {
      boxShadow: 'none',
      // Add safe area padding for mobile devices (especially in fullScreen dialogs)
      paddingTop: 'var(--safe-area-top)',
    },
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const appBar: Components<Theme> = {
  MuiAppBar,
};
